import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BranchMaintenanceComponent } from './branch-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: BranchMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BranchMaintenanceRoutingModule { }
